import React from 'react';
import { Alert, Button, Table } from 'antd';
import { ColumnsType } from 'antd/es/table';
import { PAGE_SIZE_OPTIONS } from '../const';
import * as S from '../styled';

type Props<Row> = {
    rowKey: string | ((row: Row) => string);
    columns: ColumnsType<Row>;
    data: Row[];
    total: number;
    loading: boolean;
    pagination: { page: number; perPage: number };
    onPageChange: (page: number, perPage: number) => void;
    onReset: () => void;
    isError: boolean;
    onRetry: () => void;
    emptyText: string;
    errorText: string;
};

export function ResultsTable<Row extends object>({
    rowKey,
    columns,
    data,
    total,
    loading,
    pagination,
    onPageChange,
    onReset,
    isError,
    onRetry,
    emptyText,
    errorText,
}: Props<Row>) {
    return (
        <>
            <S.ResultCount>
                A pesquisa retornou {total} resultado(s)
            </S.ResultCount>

            {isError && data.length > 0 && (
                <Alert
                    type="error"
                    showIcon
                    message={errorText}
                    action={
                        <Button size="small" type="link" onClick={onRetry}>
                            Tentar novamente
                        </Button>
                    }
                />
            )}

            <S.TableArea>
                <Table
                    rowKey={rowKey}
                    size="small"
                    columns={columns}
                    dataSource={data}
                    loading={loading}
                    scroll={{ x: 'max-content' }}
                    locale={{
                        emptyText: (
                            <S.EmptyBox>
                                <span>{isError ? errorText : emptyText}</span>
                                {isError ? (
                                    <Button type="link" onClick={onRetry}>
                                        Tentar novamente
                                    </Button>
                                ) : (
                                    <Button type="link" onClick={onReset}>
                                        Limpar filtros
                                    </Button>
                                )}
                            </S.EmptyBox>
                        ),
                    }}
                    pagination={{
                        current: pagination.page,
                        pageSize: pagination.perPage,
                        total,
                        showSizeChanger: true,
                        pageSizeOptions: PAGE_SIZE_OPTIONS,
                        onChange: onPageChange,
                    }}
                />
            </S.TableArea>
        </>
    );
}
